import { createFileRoute, getRouteApi, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Box } from '../../../components/Box.tsx'
import { Paper } from '../../../components/generic.tsx'
import { Stack } from '../../../components/Stack.tsx'
import { NavButton, ProfileMenu } from '../../../features/Navigation.tsx'
import { ids } from '../../../ids.ts'

export const Route = createFileRoute('/_app/m/_mobile')({ component: RouteComponent })

const route = getRouteApi('/_app/m/_mobile')

function RouteComponent() {
	const { t } = useTranslation()
	const navigate = route.useNavigate()
	return (
		<Box flex col full>
			<meta name='viewport' content='width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' />

			<Box flexGrow={1} overflow='hidden'>
				<Outlet />
			</Box>
			<Paper component={Stack} center sx={{ bgcolor: (t) => t.palette.brand.main, borderRadius: 0 }}>
				<NavButton data-ta={ids.navigationBar.alerts} to='/m/locations' search activeOptions={{ includeSearch: false }} fullWidth square>
					{t(($) => $.navigation.locations)}
				</NavButton>
				<NavButton data-ta={ids.navigationBar.map} to='/m/map' search activeOptions={{ includeSearch: false }} fullWidth square>
					{t(($) => $.navigation.map)}
				</NavButton>
				<ProfileMenu onPreferenceClick={() => navigate({ to: '/m/preferences' })} />
			</Paper>
		</Box>
	)
}
